/*
 * EM Wishlist Mode actif — intégration avec outils.moood.fr
 *
 * Quand un visiteur arrive avec ?em_wishlist_id=<uuid>, le site bascule en
 * mode "ajout à une wishlist existante" :
 * - Bandeau persistant en haut
 * - Tous les boutons "Wishlist" du site postent vers outils.moood au lieu de localStorage
 * - Compteurs Before / Added / Total mis à jour en live
 */
(function () {
  const KEY = 'em_wishlist_active_id';
  const API = 'https://outils.moood.fr/api/em-wishlist';
  const STATE = {
    uuid: null,
    number: '',
    email_masked: '',
    edit_token: '',
    beforeCount: 0,
    beforeTotal: 0,
    addedCount: 0,
    addedTotal: 0,
    addedItems: [],
  };

  function formatEur(cents) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format((cents || 0) / 100);
  }

  function isActive() { return !!STATE.uuid; }

  async function fetchInitialState(uuid) {
    const r = await fetch(`${API}/${uuid}`);
    if (!r.ok) {
      const j = await r.json().catch(() => ({}));
      throw new Error(j.error || `HTTP ${r.status}`);
    }
    const j = await r.json();
    if (!j.ok) throw new Error(j.error || 'unknown');
    return j;
  }

  function bannerHTML() {
    return `
      <div class="em-wm-banner" data-em-wm-banner>
        <div class="em-wm-banner__inner">
          <div class="em-wm-banner__head">
            <span class="em-wm-banner__icon" aria-hidden="true">🎁</span>
            <div class="em-wm-banner__title-block">
              <strong class="em-wm-banner__title">Mode wishlist actif</strong>
              ${STATE.number ? `<small class="em-wm-banner__sub">${STATE.number} — ${STATE.email_masked}</small>` : ''}
            </div>
          </div>
          <div class="em-wm-banner__counters">
            <span class="em-wm-banner__counter">
              <small>Avant</small>
              <strong><span data-em-wm-before-count>0</span> produits (<span data-em-wm-before-total>0,00 €</span>)</strong>
            </span>
            <span class="em-wm-banner__counter em-wm-banner__counter--added">
              <small>Ajoutés</small>
              <strong><span data-em-wm-added-count>0</span> (<span data-em-wm-added-total>0,00 €</span>)</strong>
            </span>
            <span class="em-wm-banner__counter em-wm-banner__counter--total">
              <small>Total</small>
              <strong><span data-em-wm-total-count>0</span> (<span data-em-wm-total-total>0,00 €</span>)</strong>
            </span>
          </div>
          <div class="em-wm-banner__actions">
            <button type="button" class="em-wm-banner__btn em-wm-banner__btn--ghost" data-em-wm-preview>Aperçu</button>
            <button type="button" class="em-wm-banner__btn em-wm-banner__btn--cart" data-em-wm-tocart>Ajouter au panier</button>
            <a class="em-wm-banner__btn em-wm-banner__btn--ghost" data-em-wm-view href="/pages/wishlist">Voir ma wishlist</a>
            <button type="button" class="em-wm-banner__btn em-wm-banner__btn--quit" data-em-wm-quit aria-label="Quitter">×</button>
          </div>
        </div>
      </div>
    `;
  }

  function renderBanner() {
    let banner = document.querySelector('[data-em-wm-banner]');
    if (!banner) {
      const wrap = document.createElement('div');
      wrap.innerHTML = bannerHTML();
      banner = wrap.firstElementChild;
      document.body.insertAdjacentElement('afterbegin', banner);
      document.body.classList.add('em-wm-active');
      // Attach button listeners directly (plus robuste que delegation document)
      const viewLink = banner.querySelector('[data-em-wm-view]');
      if (viewLink) {
        viewLink.href = `https://outils.moood.fr/em-wishlist/${STATE.uuid}`;
        viewLink.target = '_blank';
        viewLink.rel = 'noopener';
      }
      const previewBtn = banner.querySelector('[data-em-wm-preview]');
      if (previewBtn) previewBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); console.log('[em-wishlist-mode] Aperçu clicked'); showPreview(); });
      const cartBtn = banner.querySelector('[data-em-wm-tocart]');
      if (cartBtn) cartBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); addAllToCart(cartBtn); });
      const quitBtn = banner.querySelector('[data-em-wm-quit]');
      if (quitBtn) quitBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); quitMode(); });
    }
    updateCounters();
  }

  function updateCounters() {
    const set = (sel, val) => { const el = document.querySelector(sel); if (el) el.textContent = val; };
    set('[data-em-wm-before-count]', STATE.beforeCount);
    set('[data-em-wm-before-total]', formatEur(STATE.beforeTotal));
    set('[data-em-wm-added-count]', STATE.addedCount);
    set('[data-em-wm-added-total]', formatEur(STATE.addedTotal));
    set('[data-em-wm-total-count]', STATE.beforeCount + STATE.addedCount);
    set('[data-em-wm-total-total]', formatEur(STATE.beforeTotal + STATE.addedTotal));
  }

  // ---------- Turnstile (2026-10-06) ----------
  // L'API /items exige désormais un jeton Cloudflare Turnstile (TURNSTILE_SECRET_KEY
  // actif côté outils.moood) : sans lui, chaque ajout échouait (« Token Turnstile
  // manquant »). Widget « execution: execute » invisible sauf si un défi est nécessaire,
  // un jeton neuf par envoi (les jetons sont à usage unique).
  const TS_SITEKEY = '0x4AAAAAADSW_YnyLiummUuL';
  let tsWidget = null;
  let tsPending = null;
  function loadTurnstile() {
    return new Promise((resolve, reject) => {
      if (window.turnstile && window.turnstile.render) return resolve(window.turnstile);
      if (!document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]')) {
        const sc = document.createElement('script');
        sc.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        sc.async = true;
        document.head.appendChild(sc);
      }
      let n = 0;
      const t = setInterval(() => {
        if (window.turnstile && window.turnstile.render) { clearInterval(t); resolve(window.turnstile); }
        else if (++n > 150) { clearInterval(t); reject(new Error('Vérification anti-robot indisponible')); }
      }, 100);
    });
  }
  async function getTurnstileToken() {
    const ts = await loadTurnstile();
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => { tsPending = null; reject(new Error('Vérification anti-robot trop longue')); }, 45000);
      tsPending = (tok) => {
        clearTimeout(timer);
        tsPending = null;
        if (tok) resolve(tok); else reject(new Error('Vérification anti-robot échouée'));
      };
      if (tsWidget === null) {
        const box = document.createElement('div');
        box.className = 'em-wm-turnstile';
        document.body.appendChild(box);
        tsWidget = ts.render(box, {
          sitekey: TS_SITEKEY,
          execution: 'execute',
          appearance: 'interaction-only',
          callback: (tok) => { if (tsPending) tsPending(tok); },
          'error-callback': () => { if (tsPending) tsPending(null); },
          'expired-callback': () => {},
        });
      } else {
        try { ts.reset(tsWidget); } catch (e) {}
      }
      ts.execute(tsWidget);
    });
  }

  // Les envois sont faits l'un après l'autre (un jeton Turnstile par envoi)
  let postQueue = Promise.resolve();
  function postItems(items) {
    const run = postQueue.then(() => postItemsNow(items));
    postQueue = run.catch(() => {});
    return run;
  }

  async function postItemsNow(items) {
    if (!STATE.uuid || items.length === 0) return { ok: false };
    const normalized = items.map(it => ({
      product_id: String(it.product_id || ''),
      variant_id: String(it.variant_id || ''),
      handle: it.handle || '',
      title: it.title || '',
      type: it.type || '',
      unit_price: parseInt(it.unit_price || 0, 10),
      image: it.image || '',
      qty: Math.max(1, parseInt(it.qty || 1, 10)),
    }));
    let turnstile_token;
    try {
      turnstile_token = await getTurnstileToken();
    } catch (e) {
      console.error('[em-wishlist-mode] turnstile:', e);
      return { ok: false, error: e.message };
    }
    try {
      const r = await fetch(`${API}/${STATE.uuid}/items`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: normalized, edit_token: STATE.edit_token || undefined, turnstile_token }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.ok) {
        console.error('[em-wishlist-mode] POST items failed:', r.status, j);
        return { ok: false, error: j.error || `HTTP ${r.status}`, details: j.details };
      }
      // Update STATE from server response (canonical)
      const newTotal = parseInt(j.total_cents || 0, 10);
      const newCount = parseInt(j.items_count || 0, 10);
      // addedCount/Total = total - before
      STATE.addedCount = Math.max(0, newCount - STATE.beforeCount);
      STATE.addedTotal = Math.max(0, newTotal - STATE.beforeTotal);
      // Track items locally for "Aperçu"
      STATE.addedItems.push(...normalized);
      updateCounters();
      return { ok: true };
    } catch (e) {
      console.error('[em-wishlist-mode] network error:', e);
      return { ok: false, error: e.message };
    }
  }

  function toast(message, kind = 'ok') {
    const el = document.createElement('div');
    el.className = 'em-wm-toast em-wm-toast--' + kind;
    el.textContent = message;
    document.body.appendChild(el);
    requestAnimationFrame(() => el.classList.add('em-wm-toast--show'));
    setTimeout(() => { el.classList.remove('em-wm-toast--show'); setTimeout(() => el.remove(), 220); }, 2500);
  }

  // Intercept wishlist clicks at capture phase
  function attachInterceptor() {
    document.addEventListener('click', async (e) => {
      if (!isActive()) return;
      const btn = e.target.closest('[data-em-coll-wish]');
      if (!btn) return;
      const card = btn.closest('[data-em-coll-card]');
      if (!card) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      btn.disabled = true;
      const item = {
        product_id: card.dataset.productId,
        variant_id: card.dataset.variantId,
        handle: card.dataset.handle,
        title: card.dataset.title,
        type: card.dataset.type,
        unit_price: card.dataset.unitPrice,
        image: card.dataset.image,
        qty: 1,
      };
      const res = await postItems([item]);
      btn.disabled = false;
      if (res.ok) {
        // Visual flash
        btn.classList.add('em-flash-ok');
        setTimeout(() => btn.classList.remove('em-flash-ok'), 900);
        toast(`♥ « ${item.title} » ajouté à la wishlist`);
      } else {
        toast(`Erreur : ${res.error || 'inconnue'}`, 'error');
      }
    }, true);

    // Fiche produit : bouton « Ajouter à ma wishlist » (2026-10-06)
    document.addEventListener('click', async (e) => {
      if (!isActive()) return;
      const btn = e.target.closest('[data-em-pdp-wish]');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (btn.dataset.emBusy) return;
      btn.dataset.emBusy = '1';
      const variantEl = document.getElementById('em-pdp-variant-id');
      const qtyEl = document.getElementById('em-pdp-qty');
      const item = {
        product_id: btn.dataset.productId,
        variant_id: (variantEl && variantEl.value) || btn.dataset.variantId,
        handle: btn.dataset.handle,
        title: btn.dataset.title,
        type: btn.dataset.type,
        unit_price: btn.dataset.unitPrice, // prix revérifié côté serveur contre Shopify
        image: btn.dataset.image,
        qty: Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1),
      };
      const res = await postItems([item]);
      delete btn.dataset.emBusy;
      if (res.ok) toast(`♥ « ${item.title} » ajouté à la wishlist`);
      else toast(`Erreur : ${res.error || 'inconnue'}`, 'error');
    }, true);

    // Panier : « mettre le panier dans la wishlist » (snippet em-cart-vers-wishlist-devis)
    document.addEventListener('click', async (e) => {
      if (!isActive()) return;
      const btn = e.target.closest('[data-em-cart-to="wishlist"]');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      btn.disabled = true;
      try {
        const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        const items = (cart.items || []).map((it) => ({
          product_id: it.product_id,
          variant_id: it.variant_id,
          handle: it.handle || '',
          title: it.product_title || it.title || '',
          type: it.product_type || '',
          unit_price: it.final_price != null ? it.final_price : it.price,
          image: it.image || (it.featured_image && it.featured_image.url) || '',
          qty: it.quantity,
        }));
        if (!items.length) { toast('Votre panier est vide.', 'error'); return; }
        const res = await postItems(items);
        if (res.ok) toast(`♥ ${items.length} produit${items.length > 1 ? 's' : ''} ajouté${items.length > 1 ? 's' : ''} à la wishlist`);
        else toast(`Erreur : ${res.error || 'inconnue'}`, 'error');
      } catch (err) {
        toast('Erreur : panier illisible', 'error');
      } finally {
        btn.disabled = false;
      }
    }, true);

    // Note : les listeners des boutons du bandeau (Aperçu/Panier/Voir/Quitter)
    // sont attachés directement dans renderBanner() (pas en delegation).
  }

  function quitMode() {
    sessionStorage.removeItem(KEY);
    STATE.uuid = null;
    const banner = document.querySelector('[data-em-wm-banner]');
    if (banner) banner.remove();
    document.body.classList.remove('em-wm-active');
    // Reload sans le param
    const url = new URL(location.href);
    url.searchParams.delete('em_wishlist_id');
    location.href = url.toString();
  }

  async function showPreview() {
    let modal = document.querySelector('[data-em-wm-modal]');
    if (modal) modal.remove();
    modal = document.createElement('div');
    modal.setAttribute('data-em-wm-modal', '');
    modal.className = 'em-wm-modal';
    modal.innerHTML = `
      <div class="em-wm-modal__backdrop" data-em-wm-modal-close></div>
      <div class="em-wm-modal__panel">
        <header class="em-wm-modal__head">
          <h3>Aperçu de la wishlist</h3>
          <button type="button" class="em-wm-modal__x" data-em-wm-modal-close>×</button>
        </header>
        <div class="em-wm-modal__body">
          <div class="em-wm-modal__loading"><div class="em-wm-modal__spinner"></div></div>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    modal.addEventListener('click', (e) => {
      if (e.target.closest('[data-em-wm-modal-close]')) modal.remove();
    });
    const body = modal.querySelector('.em-wm-modal__body');

    // Fetch full state from server (canonical)
    let allItems = [];
    let totalCents = 0;
    try {
      const data = await fetchInitialState(STATE.uuid);
      allItems = data.items || [];
      totalCents = data.total_cents || 0;
    } catch (e) {
      body.innerHTML = `<p class="em-wm-modal__empty">Impossible de charger la wishlist (${escapeHtml(e.message)})</p>`;
      return;
    }

    // Marque les items ajoutés cette session via le set des product_id
    const addedKey = new Set(STATE.addedItems.map(it => String(it.product_id) + '|' + String(it.variant_id)));
    const sessionCount = STATE.addedCount;
    const sessionTotal = STATE.addedTotal;
    const initialCount = allItems.length - sessionCount;
    // Compteurs cohérents avec le bandeau (qty cumulée vs lignes uniques)
    const totalQty = allItems.reduce((s, it) => s + (parseInt(it.qty, 10) || 0), 0);

    body.innerHTML = `
      ${allItems.length === 0 ? '<p class="em-wm-modal__empty">Wishlist vide.</p>' : `
        <div class="em-wm-modal__summary">
          <span><strong>${totalQty}</strong> produits · <strong>${allItems.length}</strong> références · <strong>${formatEur(totalCents)}</strong></span>
          ${sessionCount > 0 ? `<span class="em-wm-modal__added-tag">+${sessionCount} ajoutés cette session</span>` : ''}
        </div>
        <ul class="em-wm-modal__list">
          ${allItems.map(it => {
            const key = String(it.product_id) + '|' + String(it.variant_id);
            const isNew = addedKey.has(key);
            return `
              <li class="em-wm-modal__item${isNew ? ' em-wm-modal__item--new' : ''}">
                <img src="${escapeHtml(it.image || '')}" alt="" loading="lazy">
                <div class="em-wm-modal__item-info">
                  <strong>${escapeHtml(it.title)}</strong>
                  <small>${escapeHtml(it.type || '')} · ${formatEur(it.unit_price)} × ${it.qty}</small>
                </div>
                ${isNew ? '<span class="em-wm-modal__item-badge">Nouveau</span>' : ''}
              </li>
            `;
          }).join('')}
        </ul>
      `}
    `;
  }

  async function addAllToCart(btn) {
    const orig = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Chargement…';
    try {
      // Re-fetch state pour avoir tous les items
      const data = await fetchInitialState(STATE.uuid);
      const allItems = data.items || [];
      if (allItems.length === 0) {
        toast('Wishlist vide', 'error');
        btn.disabled = false; btn.innerHTML = orig;
        return;
      }
      const cartPayload = {
        items: allItems.map(it => ({
          id: parseInt(it.variant_id, 10),
          quantity: parseInt(it.qty || 1, 10),
          properties: { _from_wishlist: STATE.number || STATE.uuid },
        })).filter(x => Number.isFinite(x.id)),
      };
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cartPayload),
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        toast('Erreur ajout panier : ' + (err.description || r.statusText), 'error');
        btn.disabled = false; btn.innerHTML = orig;
        return;
      }
      window.location.href = '/cart';
    } catch (e) {
      toast('Erreur : ' + e.message, 'error');
      btn.disabled = false; btn.innerHTML = orig;
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  async function init() {
    const params = new URLSearchParams(location.search);
    const urlId = params.get('em_wishlist_id');
    const sessionId = sessionStorage.getItem(KEY);
    const activeId = urlId || sessionId;
    if (!activeId) return;

    // Validate UUID format (basic)
    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(activeId)) {
      console.warn('[em-wishlist-mode] UUID invalide:', activeId);
      sessionStorage.removeItem(KEY);
      return;
    }

    try {
      const data = await fetchInitialState(activeId);
      STATE.uuid = activeId;
      STATE.beforeCount = data.items_count || 0;
      STATE.beforeTotal = data.total_cents || 0;
      STATE.number = data.wishlist_number || '';
      STATE.email_masked = data.contact_email_masked || '';
      STATE.edit_token = data.edit_token || ''; // Audit securite H5 (2026-07-25)
      sessionStorage.setItem(KEY, activeId);
      if (data.edit_token) sessionStorage.setItem(KEY + '_token', data.edit_token);
      // Strip URL param (keep session)
      if (urlId) {
        params.delete('em_wishlist_id');
        const newSearch = params.toString();
        history.replaceState(null, '', location.pathname + (newSearch ? '?' + newSearch : '') + location.hash);
      }
      renderBanner();
      attachInterceptor();
    } catch (e) {
      console.error('[em-wishlist-mode] init failed:', e);
      sessionStorage.removeItem(KEY);
      // Don't show banner if init fails
    }
  }

  // Exposer pour les autres scripts (em-pack.js, etc.)
  window.EMWishlistMode = {
    isActive,
    postItems,
    getState: () => ({ ...STATE }),
    toast,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
